import { useCallback, useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../../store/store";
import AttributesPicker from "../../components/attributes-picker";
import { Button } from "./../../components";
import { useUrlDefaultAttributes } from "../../hooks/useUrlDefaultAttributes";
import { getAvailableAttributes, saveAttributes } from "./../../utils";
import "./styles.scss";

function TestAttributes() {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const {
    publicTest,
    testSessionData: { sessionId },
  } = state;

  const [currentAttributes, setCurrentAttributes] = useState({});
  const [canGoNext, setCanGoNext] = useState(false);

  const availableAttributes = useMemo(
    () => getAvailableAttributes(publicTest, false),
    [publicTest]
  );

  const defaultValues = useUrlDefaultAttributes();

  const onChangeHandler = useCallback(
    attributes => {
      setCanGoNext(availableAttributes.every(attr => !!attributes[attr]));
      setCurrentAttributes(attributes);
    },
    [availableAttributes]
  );

  const onFinishTestButtonClick = useCallback(() => {
    setCanGoNext(false);
    saveAttributes({
      publicTest,
      sessionId,
      currentAttributes,
      state,
      dispatch,
      navigate,
    });
  }, [publicTest, sessionId, currentAttributes, state, dispatch, navigate]);

  //useAutoSubmit(canGoNext, allPreset, onFinishTestButtonClick);

  return (
    <div className="tg_page page test-attributes-page">
      <div className="tg_column">
        <div className="tg_attributes_page_header">
          <h2></h2>
          <div className="image-container"></div>
        </div>
        <AttributesPicker
          publicTest={publicTest}
          onChangeHandler={onChangeHandler}
          availableAttributes={availableAttributes}
          defaultValues={defaultValues}
        />
        <Button onClick={onFinishTestButtonClick} large disabled={!canGoNext}>
          {publicTest.finishButton}
        </Button>
      </div>
    </div>
  );
}

export default TestAttributes;
